import { ExpoManagedAppConfigModuleType } from './ExpoManagedAppConfig.types'

const ExpoManagedAppConfigModule: ExpoManagedAppConfigModuleType = {
  getValue(name: string) {
    return null
  },
}

export default ExpoManagedAppConfigModule
